<div>
  <!--------------------------------------------- Header ------------------------------------->
  <div class="flex flex-col w-full relative ">
    <!---------------------------------- กรอกข้อมูล --------------------------------->
    <div class="w-full bg-white dark:bg-slate-800 py-2 pb-4 px-4 m-2 shadow rounded-lg transition-colors">
      <div class="flex justify-between item-center gap-2 border-b border-gray-300 dark:border-slate-700 pb-2 mb-2">
        <div class="flex justify-center items-center gap-3 my-4">
          <div class="w-6 h-6">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAABeElEQVR4nO3R0U0DAQwEUfcCxdIChaUKamCD+AeJHLrM2Z6RXID3VZmZmZnZgXJ7vXe6z9vLW02KHjTbEegxsx2BHjJ/vPvH+0yENgDfTURoBTARoR3ANISWAJMQ2gJMQWgNMAGhPUB3hBEAnRHGAHRFGAXQEWEcQDeEkQCdEMYCdEEYDdABYTzA1RFWAFwZYQ3ALwj0/rsAfkCg928DkJOO3l8AOnqACMCPEAH2XtHRA0QAfoQIsPeKjh4gAvAjRIC9V3T0ABGAHyEC7L2i++8DV0kAOAHgBIBbC5DmR+8vAB09QATgR4gAx+9ZCSDAOQkAJwDcWY+lydH7C0BHDxAB+BEiwPG7SgLACQAnANxagDQ/en8B6OgBIgA/QgQ4fs9KAAHOSQA4AeDOeixNjt5fADp6gAjAjxAB9l7R0QNEAH6ECLD3io4eIALwI0SAvVd09AARgB8hAuy9oqMHiAD8CBFg7xUdPUAE4EeIAHuvzMzMzKwe7wua0JpBUSg/4wAAAABJRU5ErkJggg=="
              alt="document--v1">
          </div>
          <p class="text-yellow-300 text-lg font-semibold ">กรอกข้อมูลบัตรจอดรถ</p>
        </div>
        <div class="flex items-center gap-2 my-2">
          <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
            class="px-4 py-2 rounded-md border border-slate-200 dark:border-slate-600 text-slate-600 dark:text-slate-300 font-bold hover:border-amber-400 hover:text-amber-600 transition-all inline-flex items-center gap-1.5 text-sm">
            <span class="material-icons text-[18px]">history</span>
            ดูประวัติ
          </button>
          <button
            class="bg-yellow-300 flex justify-center items-center border border-yellow-300 px-4 rounded-md text-sm text-gray-700 gap-2">
            <p class=" text-white" (click)="onClickCreateCodeMember()">สร้างบัตรสมาชิก</p>
          </button>
        </div>
        <!-------------------------------------------- ปุ่มบันทึก ------------------------------------->
        <!-- <div class="flex justify-end mt-4 max-h-10" *ngIf="!isDisableInput">
                <button
                    (click)="onClickSaveCardAdvance()"
                    class="px-6 py-2 bg-blue-400 text-white text-sm rounded hover:bg-blue-400"
                >
                    บันทึก
                </button>
              </div> -->
      </div>
      <!--------- สถานที่ ---------->
      <div class="relative pb-3">
        <label class="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
          สถานที่ให้บริการลานจอด
        </label>
        <div class="flex gap-2">
          <input type="text" [value]="siteName" readonly [disabled]="isDisableInput"
            class="flex-1 px-3 py-2 text-sm border dark:border-slate-600 rounded-md bg-gray-100 dark:bg-slate-700 dark:text-slate-200 focus:outline-none focus:ring focus:ring-blue-300 transition-colors" />
          <button type="button" *ngIf="!isDisableInput" (click)="showSelectProviderModal = true"
            class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-red-600 whitespace-nowrap rounded-md">
            เลือก
          </button>
        </div>
      </div>

      <div>
        <div
          class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full pb-2">
          <!--------- ชื่อบัตรจอดรถ ---------->
          <div class="w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-slate-300 pb-2">ชื่อบัตรจอดรถ</p>
            <input type="text" class="w-full bg-gray-50 dark:bg-slate-900 border border-gray-300 dark:border-slate-700 flex-1 px-3 py-2 text-sm text-slate-900 dark:text-white
                        focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg transition-colors"
              placeholder="กรุณากรอกชื่อ" [(ngModel)]="cardAdvanceApprovePayloadModel.name" [disabled]="isDisableInput"
              (input)="onChangeValidateText('name', cardAdvanceApprovePayloadModel.name)" />
            <!-- แจ้งเตือน -->
            <p class="text-red-500 text-xs mt-1" *ngIf="isTextValid.where === 'name' && !isTextValid.result">
              กรุณากรอกตัวอักษรให้ถูกต้อง
            </p>
          </div>
          <!--------- ประเภทบัตรจอดรถ ---------->
          <div class="relative  w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-slate-300 pb-2">ประเภทบัตรจอดรถ</p>
            <!-- ปุ่มเลือกประเภทบัตรจอดรถ -->
            <div *ngIf="!isDisableInput"
              class="w-full bg-gray-50 dark:bg-slate-900 border border-gray-300 dark:border-slate-700 flex-1 px-3 py-2 text-sm rounded-lg transition-colors
                              focus:outline-none focus:ring focus:ring-yellow-200 cursor-pointer flex justify-between items-center"
              (click)="isDisableInput ? null : isOpenSelectVehicleTypeId = !isOpenSelectVehicleTypeId">
              <span
                ngClass="{{!selectVehicleTypeId.name  ? 'text-gray-500 dark:text-slate-400' : 'text-slate-900 dark:text-white'}}">
                {{selectVehicleTypeId.name || 'กรุณาเลือกประเภท' }}
              </span>
              <svg *ngIf="!isDisableInput" class="w-4 h-4 ml-2 dark:text-gray-300" fill="none" stroke="currentColor"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <!-- ตัวเลือกประเภทบัตรจอดรถ -->
            <div
              class="absolute left-0 right-0 mt-1 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-700 rounded-lg shadow z-10"
              *ngIf="isOpenSelectVehicleTypeId">
              <div *ngFor="let item of optionCardTypeID"
                class="px-3 py-2 text-slate-700 dark:text-slate-200 hover:bg-yellow-100 dark:hover:bg-slate-700 cursor-pointer transition-colors"
                (click)="onClickSelectVehicleTypeId(item)">
                {{ item.name }}
              </div>
            </div>

            <app-input *ngIf="isDisableInput" [type]="'text'" [valueIn]="cardAdvanceApprovePayloadModel.vehicleTypeName"
              [readOnly]="true"></app-input>
          </div>
        </div>
        <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full">
          <!--------- วันที่เริ่มต้น ---------->
          <div class="w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-slate-300 pb-2">วันที่เริ่มต้น</p>
            <input *ngIf="!isDisableInput" type="date" class="w-full bg-gray-50 dark:bg-slate-900 border border-gray-300 dark:border-slate-700 flex-1 px-3 py-2 text-sm text-slate-900 dark:text-white
                        focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg transition-colors"
              [(ngModel)]="cardAdvanceApprovePayloadModel.startDate" />
            <div *ngIf="isDisableInput" type="text" class="w-full bg-gray-50 dark:bg-slate-900 border border-gray-300 dark:border-slate-700 flex-1 px-3 py-2 text-sm text-slate-900 dark:text-white
                        focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg transition-colors">
              {{ cardAdvanceApprovePayloadModel.startDate | date: 'dd/MM/yyyy' }}
            </div>
          </div>
          <!--------- วันที่สิ้นสุด ---------->
          <div class="w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-slate-300 pb-2">วันที่สิ้นสุด</p>
            <input type="date" class="w-full bg-gray-50 dark:bg-slate-900 border border-gray-300 dark:border-slate-700 flex-1 px-3 py-2 text-sm text-slate-900 dark:text-white
                        focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg transition-colors"
              placeholder="กรุณากรอกวันที่สิ้นสุด" *ngIf="!isDisableInput"
              [(ngModel)]="cardAdvanceApprovePayloadModel.endDate" />
            <div *ngIf="isDisableInput" type="text" class="w-full bg-gray-50 dark:bg-slate-900 border border-gray-300 dark:border-slate-700 flex-1 px-3 py-2 text-sm text-slate-900 dark:text-white
                        focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg transition-colors">
              {{ cardAdvanceApprovePayloadModel.endDate | date: 'dd/MM/yyyy' }}
            </div>
          </div>
        </div>
        <!--------- จํานวนบัตร ---------->
        <div class="w-full mt-2">
          <p class="text-sm text-gray-700 dark:text-slate-300 pb-2">จํานวนบัตร</p>
          <input type="number" class="w-full bg-gray-50 dark:bg-slate-900 border border-gray-300 dark:border-slate-700 flex-1 px-3 py-2 text-sm text-slate-900 dark:text-white
                      focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg transition-colors"
            placeholder="กรุณากรอกจำนวนบัตร" [disabled]="isDisableInput"
            [(ngModel)]="cardAdvanceApprovePayloadModel.qty" max="1000" min="1" />
          <!-- แจ้งเตือน -->
          <!-- <p class="text-red-600 text-xs mt-1" 
                      *ngIf="isNumberValid.where === 'qty' && !isNumberValid.result"
                  >
                      กรุณากรอกตัวเลขให้ถูกต้อง
                  </p> -->
        </div>

      </div>
      <!-------------------------------------------- หมายเหตุ ------------------------------------>
      <div>
        <p class="text-sm text-gray-700 dark:text-slate-300 py-2">หมายเหตุ</p>
        <textarea class="w-full border border-gray-300 dark:border-slate-700 flex-1 px-3 py-2 text-sm text-slate-900 dark:text-white
                    focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg transition-colors" [ngClass]="{ 
                        'bg-gray-100 dark:bg-slate-800': isDisableRemark,
                        'bg-gray-50 dark:bg-slate-900': !isDisableRemark
                    }" placeholder="กรุณากรอกหมายเหตุ" [(ngModel)]="cardAdvanceApprovePayloadModel.remark"
          [disabled]="isDisableRemark"></textarea>
      </div>
      <div class="flex flex-col space-y-2">


      </div>
    </div>
    <!--------------------------------------------- Body ------------------------------------->
    <div class="flex flex-col w-full bg-white dark:bg-slate-800 shadow py-2 m-2 rounded-xl transition-colors">
      <div class="flex item-center gap-2 p-2" *ngIf="isDisableInput">

        <button
          class="bg-green-500 hover:bg-green-600 flex justify-center items-center border border-green-500 px-4 py-2 rounded-md text-sm text-white gap-2 transition-colors"
          (click)="onExportToExcel()">
          ดาวน์โหลด Excel
        </button>

      </div>
      <div class="w-full h-0.5 bg-gray-200 dark:bg-slate-700 my-2" *ngIf="!isDisableInput"></div>
      <div class="overflow-x-auto shadow-lg rounded-2xl border border-gray-200 dark:border-slate-700 mx-2 mb-2">
        <table class="min-w-full divide-y divide-gray-200 dark:divide-slate-700 text-sm">
          <thead class="bg-gray-100 dark:bg-slate-900 text-gray-700 dark:text-slate-300 uppercase text-xs">
            <tr>
              <th class="px-4 py-4 text-left">No.</th>
              <th class="px-4 py-4 text-left">ชื่อ</th>
              <th class="px-4 py-4 text-left">code</th>
              <th class="px-4 py-4 text-left">เบอร์โทร</th>
              <th class="px-4 py-4 text-left">ป้ายทะเบียน</th>
              <th class="px-4 py-4 text-left">วันที่เริ่มใช้งาน</th>
              <th class="px-4 py-4 text-cener">สถานะ</th>
            </tr>
          </thead>
          <tbody
            class="divide-y divide-gray-100 dark:divide-slate-700 bg-white dark:bg-slate-800 text-gray-800 dark:text-slate-200">
            <tr *ngFor="let d of cardAdvanceApproveDetailsModel; let i = index"
              class="hover:bg-gray-50 dark:hover:bg-slate-700/50 transition-colors">
              <td class="px-4 py-4" *ngIf="i+1 <= 100">{{ i + 1 }}</td>
              <td class="px-4 py-4" *ngIf="i+1 <= 100">{{ d.name }}</td>
              <td class="px-4 py-4 flex items-center gap-1" *ngIf="i+1 <= 100">
                <label class="w-40">{{ d.code }}</label>
                <div class="w-4 h-4 cursor-pointer opacity-70 hover:opacity-100 dark:invert"
                  (click)="onClickCopyCode(d.code)">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACpElEQVR4nO3csWoUURQG4IOKWqgPoJYimE723lEECTaCkjaPYOcaNPes5T6E4otYWFpFsYqBgLi5J0HUykpUNNXKmE52N7PZyZxzZv4f/nJ2Z77cnZk9S4YIQRAEQRCktRnuLZ/lHNZSju84x58scXzcTRL3k8SNgfQK6kIGo+Iy57DVBO5E8Bx+p93iLnVgJW9pIXcGm3NY00buBHYqz8kGkFuPnST+0AGNvzqFzWqrt7h9yB/5D0tcobaElaAP3rtD2KwI3SlsVobuDDYbgO4ENhuBbj02G4JuNTYbg24tNhuENo89a9TpDboM7xR3zH2DPGzU6RHaHHaVUadX6KrYjfx4UGXUaQ2aP12/WCu2xA2yMOo0B53j03mPcxZ2+bMYWRh1WoNOEvdL7DpXdi2YM9+8woEtsi07KaAF0KSNA2jxV0ALoEkbB9Dir4AWQJM2DqDFXwEtgCZtHECLvwJaAE3aOIAWfwW0AJq0cQAt/gpoATRp4wBa/BXQAmjSxgG0+CugBdCkjQNo8VdAC6BJGwfQ4q+AFkCTNk7roPnDrfOWHozCtTd8NwH9ROJVD4/64SM25fDWBPR6Dvcmbbue4yNtpDo6kN5DE9Cc4/NJ2/ZHV86kHN5rQy3UHDaH20unTUAnCZ+Hr5dPTfuv2+QVO4fNxx9vXjp25KrQ/7B344Npr9EvV/ZO7JfnOusXyIP9C2/K00UjK3lu6By/Trv7QCpkvhURXq2OV09q77PLzP3Ry/HZcEwntPfbXY50nsvhZX9UXNDed1dZ4MLyrXwywrS7EeS/LH4lD19YwgvOvfuDvRvXhttL57SPyWS0b7e4xpLlaOMwoP2VLMf6Nzm2NOpcJBh1NhSMOhsKRp0NBqPOBoNRJ4IgCIIgCIIgCLUjfwGnfrd/uiaR+AAAAABJRU5ErkJggg=="
                    alt="copy">
                </div>
              </td>
              <td class="px-4 py-4" *ngIf="i+1 <= 100">{{ d.phone }}</td>
              <td class="px-4 py-4" *ngIf="i+1 <= 100">{{ d.plateNumber }}</td>
              <td class="px-4 py-4" *ngIf="i+1 <= 100">{{ d.activateDate | date: 'dd/MM/yyyy' }}</td>
              <td class="px-2 py-2  " *ngIf="i+1 <= 100">
                <label class="p-2  rounded-md text-sm text-gray-700 text-center" [ngClass]="{ 
                          'bg-red-100 bg-opacity-80 text-red-700': !d.status,
                          'bg-green-100 bg-opacity-80 text-green-700': d.status
                      }">
                  {{ d.status
                  ? "เปิดใช้งาน"
                  : "ไม่เปิดใช้งาน"
                  }}
                </label>
              </td>
              <td class="px-2 py-2" *ngIf="!isDisableInput && i+1 <= 100">
                <button (click)="onClickDeleteCardAdvanceApproveDetails(i)" class="bg-red-500 bg-opacity-50 px-4 py-2 rounded-md text-sm text-red-500 
                           hover:text-red-700 hover:bg-red-400
                          ">
                  ลบ
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>



    </div>
    <!--------------------------------------------- Footer ------------------------------------->
    <div>

    </div>
  </div>


  <app-modal-admin-activity-history
    *ngIf="showActivityHistory && couponEntityId"
    [entityType]="activityEntityTypes.FinanceCoupon"
    [entityId]="couponEntityId"
    title="ประวัติคูปอง"
    [subtitle]="'#' + couponEntityId"
    (close)="closeActivityHistory()">
  </app-modal-admin-activity-history>

  <!--------------------------------------------- Modal ------------------------------------->